import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OrderSchema {
  customerName: string
  tradeInManufacturer: string
  paymentAccountHolder: string
  paymentIban: string
}

interface OrderInstance {
  [key: string]: OrderSchema
}

interface OrderState {
  current: string
  records: OrderInstance
}

const initialState: OrderState = {
  current: '',
  records: {},
}

export const OrderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setCurrentOrder: (state, action: PayloadAction<string>) => {
      state.current = action.payload
    },
    unsetCurrentOrder: state => {
      state.current = ''
    },
    saveOrder: (state, action: PayloadAction<Partial<OrderSchema>>) => {
      // Object.assign(state, action.payload)
      state.records[state.current] = {
        ...state.records[state.current],
        ...action.payload,
      }
    },
    clearOrders: () => initialState,
  },
})

export const { setCurrentOrder, unsetCurrentOrder, saveOrder, clearOrders } = OrderSlice.actions

export default OrderSlice.reducer
